/* eslint-disable */
import BookerService from '@/services/BookerService.js'
import EterminService from '@/services/EterminService.js'
import EterminDeprecatedService from '@/services/EterminDeprecatedService.js'
//import DrupalMailService from '@/services/DrupalMailService.js'

import moment from 'moment'

export const namespaced = true // ensures all mutations, actions and getters are namespaced under event.

moment.locale('de')
const yesterday = new Date(moment().subtract(1, 'days'))
const threemonths = new Date(moment().add(3, 'months').subtract(1, 'days'))

export const state = {
    services: [],
    reservation : {
        id: null,
        secret: null,
        reservedUntil: null
    },
    customFields:{},
    calenderServices: [],
    selectedServices: [],
    generatedAppointement: {
        id: 0,
        externalid: '',
        start: null,
        end: null,
        capmax: 0,
        calenderid: '',
        secret :'',
        services: [],
        contact: {
            salutation: '',
            firstname: '',
            lastname: '',
            telephone: '',
            email: '',
            desc: ''
        },
        reasonleave: '',
        promoted: '',
        deleted: false
    },
    created: false,
    calender: {
        date: null,
        disabledDates: {
            to: yesterday,
            from: threemonths
        },
        highlighted: {
            dates: [],
            includeDisabled: true
        },
        times: []
    },
    steps: [
        {
            'name': 'Service',
            'title': Drupal.t('What can we do for you?'),
            'description': Drupal.t('Please select one of the available services'),
            'error': Drupal.t('An error occurred when querying the services.'),
            'validation': {
                'status': 0,
                'msg': Drupal.t('Please select one of the services listed above.')
            },
            'status': 'active',
            'url': '#',
            'tracking': {
                'ga': ['pageview', 'service']
            }
        },
        {
            'name': Drupal.t('Appointment'),
            'title': Drupal.t('Which date suits you best?'),
            'description': Drupal.t('Please choose a suitable date and time.'),
            'error': Drupal.t('There was an error querying the dates.'),
            'validation': {
                'status': 0,
                'msg': Drupal.t('Please select an appointment.')
            },
            'status': 'disabled',
            'url': '#',
            'tracking': {
                'ga': ['pageview', 'termin']
            }
        },
        {
            'name': Drupal.t('Data'),
            'title': Drupal.t('Who comes to the appointment?'),
            'description': Drupal.t('Please enter your personal data.'),
            'error': Drupal.t('There was an error submitting the form data. Reason could be that the appointment was already booked.'),
            'validation': {
                'status': 0,
                'msg': Drupal.t('Please fill out the form.')
            },
            'status': 'disabled',
            'url': '#',
            'tracking': {
                'ga': ['pageview', 'kontaktdaten']
            }
        },
        {
            'name': Drupal.t('Ready'),
            'title': Drupal.t('Your appointment was booked'),
            'description': Drupal.t('We are looking forward to your visit.'),
            'validation': {
                'status': 0,
                'msg': ''
            },
            'status': 'disabled',
            'url': '#',
            'tracking': {
                'ga': ['pageview', 'abschluss']
            }
        },
        {
            'name': Drupal.t('Cancellation'),
            'title': Drupal.t('Your appointment cancellation'),
            'description': Drupal.t('We hope to see you in one of our branches in the future.'),
            'error': Drupal.t('There was an error deleting appointement.'),
            'hidden': true,
            'validation': {
                'status': 0,
                'msg': ''
            },
            'status': 'disabled',
            'url': '#',
            'tracking': {
                'ga': ['pageview', 'service']
            }
        }
    ]
}

export const mutations = {
    PUSH_SERVICES (state, data) {
        state.services = data
    },
    PUSH_CALENDER (state, data) {
        state.calender.disabledDates.to = data.dateBegin
        state.calender.disabledDates.from = data.dateEnd
    },
    PUSH_FIELDS (state, data) {
        state.customFields = data
    },
    PUSH_SELECTED_SERVICES (state, data) {
        state.selectedServices = []
        data.forEach(id => {
            state.selectedServices.push(getters.getServiceName(state)(id))
        })
    },
    PUSH_ACTIVE_DATES (state, data) {
        state.calender.highlighted.dates = []
        data.forEach(date => {
            state.calender.highlighted.dates.push(moment(date).toDate())
        })
        if (state.calender.date == null) {
            state.calender.date = state.calender.highlighted.dates[ 0 ]
        }
    },
    PUSH_TIMES (state, data) {
        state.calender.times = []
        data[0].times.forEach(time => {
            state.calender.times.push({
                date : data[0].day,
                time : time,
            })
        })
    },
    PUSH_RESERVATION (state, data) {
        state.reservation = data
    },
    DELETE_RESERVATION (state) {
        state.reservation.id = null
        state.reservation.secret = null
        state.reservation.reservedUntil = null
    },
    PUSH_GENEREATED_APPOINTEMENT (state, data) {
        state.generatedAppointement.externalid = data.id
        state.generatedAppointement.start = data.bookings[0].interval.begin
        state.generatedAppointement.end = data.bookings[0].interval.end
        state.generatedAppointement.calenderid = data.calenderid
        state.generatedAppointement.secret = data.reschedulingSecret
        state.generatedAppointement.rescheduleUntil = data.rescheduleUntil
        state.generatedAppointement.services = data.serviceId
        state.generatedAppointement.contact.firstname = data.singleCustomers[0].firstName
        state.generatedAppointement.contact.lastname = data.singleCustomers[0].lastName
        state.generatedAppointement.contact.telephone = data.singleCustomers[0].phone
        state.generatedAppointement.contact.email = data.singleCustomers[0].email
    },
    PUSH_DEPRECATED_GENEREATED_APPOINTEMENT (state, data) {
        state.generatedAppointement.externalid = data.ExternalID
        state.generatedAppointement.start = data.StartDateTime
        state.generatedAppointement.end = data.EndDateTime
        state.generatedAppointement.calenderid = data.CalendarID
        state.generatedAppointement.services = data.SelectedAnswers.split(',')
        state.generatedAppointement.contact.salutation = data.FirstName
        state.generatedAppointement.contact.firstname = data.FirstName
        state.generatedAppointement.contact.lastname = data.LastName
        state.generatedAppointement.contact.telephone = data.Email
        state.generatedAppointement.contact.email = data.Phone
        state.generatedAppointement.contact.desc = data.Notes
    },
    SET_APPOINTEMENT_DELETED (state) {
        state.generatedAppointement.deleted = true
    },
    SET_DATE (state, date) {
        state.calender.date = date
    },
    SET_STEP (state, index) {
        state.steps.filter((step, key) => key < index)
            .map(function (obj) {
                obj.status = 'archived'
            })
        state.steps.filter((step, key) => key === index).map(function (obj) {
            obj.status = 'active'
        })
        state.steps.filter((step, key) => key > index).map(function (obj) {
            obj.status = 'disabled'
        })
    },
    VALIDATE_STEP (state, data) {
        state.steps[data.index].validation.status = data.status
    },
    SET_CREATED (state, data) {
        state.created = data
    }
}

export const actions = {
    selectServices ({commit, dispatch, state}, {services}) {
        commit('PUSH_SELECTED_SERVICES', services)
    },
    fetchServices ({commit, dispatch, state}, {store}) {
        dispatch('startLoading', { message: Drupal.t('Getting services ...') }, { root: true })
        BookerService.getServices(store.calenderid)
            .then(response => {
                    if (response.data.error !== undefined) {
                    const notification = {
                        type: 'error',
                        message: state.steps[getters.getActiveStep(state)].error,
                        sending: {
                            type: response.data.message.indexOf('timeout') !== -1 ? 'timeout' : 'api-error',
                            source: '/get/companies',
                            referer: window.location.href,
                            error: `Error ${response.data.error} : ${response.data.message}`,
                            filial: `${store.title}__${store.path}`,
                            calenderid: store.calenderid,
                            step: `${(getters.getActiveStep(state) + 1)}) ${state.steps[getters.getActiveStep(state)].name}`,
                            _step_id: (getters.getActiveStep(state) + 1),
                            _step_name: state.steps[getters.getActiveStep(state)].name
                        }
                    }
                    dispatch('notification/add', notification,
                        {
                            root: true
                        }
                    )
                    dispatch('errorLoading', null,
                        {
                            root: true
                        }
                    )
                } else {

                    let fields = response.data.data.companies[0].customerFields;
                    if (fields.length > 0) {
                        commit('PUSH_FIELDS', fields)
                    }
                    else {
                        const notification = {
                            type: 'error',
                            message: Drupal.t('There are currently fields to choose from them.'),
                            sending: {
                                type: 'data-non-available',
                                source: '/get/companies',
                                referer: window.location.href,
                                error: 'No active fields available for this store.',
                                filial: `${store.title}__${store.path}`,
                                calenderid: store.calenderid,
                                step: `${(getters.getActiveStep(state) + 1)}) ${state.steps[getters.getActiveStep(state)].name}`,
                                _step_id: (getters.getActiveStep(state) + 1),
                                _step_name: state.steps[getters.getActiveStep(state)].name
                            }
                        }
                        dispatch('notification/add', notification,
                            {
                                root: true
                            }
                        )
                        dispatch('errorLoading', null,
                            {
                                root: true
                            }
                        )
                    }

                    let services = response.data.data.companies[0].services;

                    if (services.length > 0) {
                        commit('PUSH_SERVICES', services)
                    } else {
                        const notification = {
                            type: 'error',
                            message: Drupal.t('There are currently no services to choose from.'),
                            sending: {
                                type: 'data-non-available',
                                source: '/get/companies',
                                referer: window.location.href,
                                error: 'No active services available for this store.',
                                filial: `${store.title}__${store.path}`,
                                calenderid: store.calenderid,
                                step: `${(getters.getActiveStep(state) + 1)}) ${state.steps[getters.getActiveStep(state)].name}`,
                                _step_id: (getters.getActiveStep(state) + 1),
                                _step_name: state.steps[getters.getActiveStep(state)].name
                            }
                        }
                        dispatch('notification/add', notification,
                            {
                                root: true
                            }
                        )
                        dispatch('errorLoading', null,
                            {
                                root: true
                            }
                        )
                    }
                }
             })
            .finally(() => {
                dispatch('stopLoading', null,
                    {
                        root: true
                    }
                )
            })
            .catch(error => {
                console.log(error);
                const notification = {
                    type: 'error',
                    message: state.steps[getters.getActiveStep(state)].error,
                    sending: {
                        type: error.message.indexOf('timeout') !== -1 ? 'timeout' : 'api-error',
                        source: '/get/companies',
                        referer: window.location.href,
                        error: error.message,
                        filial: `${store.title}__${store.path}`,
                        calenderid: store.calenderid,
                        step: `${(getters.getActiveStep(state) + 1)}) ${state.steps[getters.getActiveStep(state)].name}`,
                        _step_id: (getters.getActiveStep(state) + 1),
                        _step_name: state.steps[getters.getActiveStep(state)].name
                    }
                }
                dispatch('notification/add', notification,
                    {
                        root: true
                    }
                )
                dispatch('errorLoading', null,
                    {
                        root: true
                    }
                )
            })
    },
    getTimesSlots ({ commit, dispatch, state }, {date, rangesearch, store, services}) {
        BookerService.getTimeSlots(date, store.calenderid, services)
            .then(response => {
                 if (response.data.error !== undefined) {
                    const notification = {
                        type: 'error',
                        message: state.steps[getters.getActiveStep(state)].error,
                        sending: {
                            type: response.data.message.indexOf('timeout') !== -1 ? 'timeout' : 'api-error',
                            source: 'get/availabilities',
                            referer: window.location.href,
                            error: `Error ${response.data.error} : ${response.data.message}`,
                            filial: `${store.title}__${store.path}`,
                            calenderid: store.calenderid,
                            services: state.selectedServices.join(','),
                            step: `${(getters.getActiveStep(state) + 1)}) ${state.steps[getters.getActiveStep(state)].name}`,
                            _step_id: (getters.getActiveStep(state) + 1),
                            _step_name: state.steps[getters.getActiveStep(state)].name
                        }
                    }
                    dispatch('notification/add', notification,
                        {
                            root: true
                        }
                    )
                    dispatch('errorLoading', null,
                        {
                            root: true
                        }
                    )
                }
                else{
                    let data = response.data.data;
                    if (rangesearch === 1) {
                        if (data['onDays'].length === 0) {
                            const notification = {
                                type: 'error',
                                message: Drupal.t('No available timeslots related to calenderid.'),
                                sending: {
                                    type: 'data-non-available',
                                    source: 'get/availabilities',
                                    referer: window.location.href,
                                    error: 'There are no dates available for the selected services. Please try again later.',
                                    filial: `${store.title}__${store.path}`,
                                    calenderid: store.calenderid,
                                    services: state.selectedServices.join(','),
                                    step: `${(getters.getActiveStep(state) + 1)}) ${state.steps[getters.getActiveStep(state)].name}`,
                                    _step_id: (getters.getActiveStep(state) + 1),
                                    _step_name: state.steps[getters.getActiveStep(state)].name
                                }
                            }
                            dispatch('notification/add', notification,
                                {
                                    root: true
                                }
                            )
                            dispatch('errorLoading', null,
                                {
                                    root: true
                                }
                            )
                        } else {
                            let dateBegin =  new Date(moment(data['calendarBegin']).subtract(1, 'days'));
                            let dateEnd = new Date(moment(data['calendarEnd']));
                            commit('PUSH_CALENDER', {dateBegin,dateEnd})
                            commit('PUSH_ACTIVE_DATES', data['onDays'])
                        }
                    } else {
                        commit('PUSH_TIMES', data['slots'])
                    }
                }
            })
            .finally(() => {
                dispatch('stopLoading', null,
                    {
                        root: true
                    }
                )
            })
            .catch(error => {
                const notification = {
                    type: 'error',
                    message: state.steps[getters.getActiveStep(state)].error,
                    direct: true,
                    sending: {
                        type: error.message.indexOf('timeout') !== -1 ? 'timeout' : 'api-error',
                        source: 'get/availabilities',
                        referer: window.location.href,
                        error: error.message,
                        filial: `${store.title}__${store.path}`,
                        calenderid: store.calenderid,
                        services: state.selectedServices.join(','),
                        step: `${(getters.getActiveStep(state) + 1)}) ${state.steps[getters.getActiveStep(state)].name}`,
                        _step_id: (getters.getActiveStep(state) + 1),
                        _step_name: state.steps[getters.getActiveStep(state)].name
                    }
                }
                dispatch('notification/add', notification,
                    {
                        root: true
                    }
                )
                dispatch('errorLoading', null,
                    {
                        root: true
                    }
                )
            })
    },
    getCustomersCustomFields ({ commit, dispatch, state }, {calenderid}) {
        dispatch('startLoading', { message: Drupal.t('Getting custom fields ...') }, { root: true })
        EterminService.getCustomersCustomFields(calenderid)
            .then(response => {
                if (response.data.error !== undefined) {
                    const notification = {
                        type: 'error',
                        message: state.steps[getters.getActiveStep(state)].error,
                        direct: true,
                        sending: {
                            type: response.data.message.indexOf('timeout') !== -1 ? 'timeout' : 'api-error',
                            source: 'get/customers/customfields',
                            referer: window.location.href,
                            error: `Error ${response.data.error} : ${response.data.message}`,
                            calenderid: calenderid,
                            _step_id: (getters.getActiveStep(state) + 1),
                            _step_name: state.steps[getters.getActiveStep(state)].name
                        }
                    }
                    dispatch('notification/add', notification,
                        {
                            root: true
                        }
                    )
                    dispatch('errorLoading', null,
                        {
                            root: true
                        }
                    )
                } else {
                    let fields = response.data.data
                    if (fields.length > 0) {
                        commit('PUSH_FIELDS', fields)
                    }
                    else {
                        const notification = {
                            type: 'error',
                            message: Drupal.t('There are currently fields to choose from them.'),
                            sending: {
                                type: 'data-non-available',
                                source: 'get/customers/customfields/',
                                referer: window.location.href,
                                error: 'No active fields available for this store.',
                                filial: `${store.title}__${store.path}`,
                                calenderid: store.calenderid,
                                step: `${(getters.getActiveStep(state) + 1)}) ${state.steps[getters.getActiveStep(state)].name}`,
                                _step_id: (getters.getActiveStep(state) + 1),
                                _step_name: state.steps[getters.getActiveStep(state)].name
                            }
                        }
                        dispatch('notification/add', notification,
                            {
                                root: true
                            }
                        )
                        dispatch('errorLoading', null,
                            {
                                root: true
                            }
                        )
                    }
                }
            }).finally(() => {
            dispatch('stopLoading', null,
                {
                    root: true
                }
            )
        })
        .catch(error => {
            const notification = {
                type: 'error',
                message: state.steps[getters.getActiveStep(state)].error,
                direct: true,
                sending: {
                    type: error.message.indexOf('timeout') !== -1 ? 'timeout' : 'api-error',
                    source: 'get/customers/customfields/',
                    referer: window.location.href,
                    error: error.message,
                    calenderid: calenderid,
                    services: state.selectedServices.join(','),
                    step: `${(getters.getActiveStep(state) + 1)}) ${state.steps[getters.getActiveStep(state)].name}`,
                    _step_id: (getters.getActiveStep(state) + 1),
                    _step_name: state.steps[getters.getActiveStep(state)].name
                }
            }
            dispatch('notification/add', notification,
                {
                    root: true
                }
            )
            dispatch('errorLoading', null,
                {
                    root: true
                }
            )
        })
    },
    createReservation ({ commit, dispatch, state }, {store, calenderid, services ,date, time}) {
      dispatch('startLoading', { message: Drupal.t('Creating reservation ...') }, { root: true })
      BookerService.createReservation(calenderid,  services , date, time)
        .then(response => {
          if (response.data.error !== undefined) {
                const notification = {
                    type: 'error',
                    message: state.steps[getters.getActiveStep(state)].error,
                    direct: true,
                    sending: {
                        type: response.data.message.indexOf('timeout') !== -1 ? 'timeout' : 'api-error',
                        source: 'post/reservations',
                        referer: window.location.href,
                        error: `Error ${response.data.error} : ${response.data.message}`,
                        filial: `${store.title}__${store.path}`,
                        calenderid: store.calenderid,
                        appointement: `${date} - ${time}`,
                        services: state.selectedServices.join(','),
                        step: `${(getters.getActiveStep(state) + 1)}) ${state.steps[getters.getActiveStep(state)].name}`,
                        _step_id: (getters.getActiveStep(state) + 1),
                        _step_name: state.steps[getters.getActiveStep(state)].name
                    }
                }
                dispatch('notification/add', notification,
                    {
                        root: true
                    }
                )
                dispatch('errorLoading', null,
                    {
                        root: true
                    }
                )
          }
          else{
                let data = response.data.data;
                commit('PUSH_RESERVATION', data)
          }
        })
        .finally(() => {
                dispatch('stopLoading', null,
            {
                root: true
            }
        )
        })
        .catch(error => {
                const notification = {
                    type: 'error',
                    message: state.steps[getters.getActiveStep(state)].error,
                    direct: true,
                    sending: {
                        type: error.message.indexOf('timeout') !== -1 ? 'timeout' : 'api-error',
                        source: 'post/reservations',
                        referer: window.location.href,
                        error: error.message,
                        filial: `${store.title}__${store.path}`,
                        calenderid: store.calenderid,
                        appointement: `${date} - ${time}`,
                        services: state.selectedServices.join(','),
                        step: `${(getters.getActiveStep(state) + 1)}) ${state.steps[getters.getActiveStep(state)].name}`,
                        _step_id: (getters.getActiveStep(state) + 1),
                        _step_name: state.steps[getters.getActiveStep(state)].name
                    }
                }
                dispatch('notification/add', notification,
            {
                root: true
            }
        )
            dispatch('errorLoading', null,
                {
                    root: true
                }
            )
        })
    },
    deleteReservation ({ commit, dispatch, state }, {store, calenderid, reservation_id , reason ,cancellation , secret}) {
        dispatch('startLoading', { message: Drupal.t('Deleting reservation ...') }, { root: true })
        BookerService.deleteReservation(calenderid, reservation_id , secret , reason)
            .then(response => {
        if (response.data.error !== undefined) {
            const notification = {
                type: 'error',
                message: state.steps[getters.getActiveStep(state)].error,
                direct: true,
                sending: {
                    type: response.data.message.indexOf('timeout') !== -1 ? 'timeout' : 'api-error',
                    source: 'delete/reservations',
                    referer: window.location.href,
                    error: `Error ${response.data.error} : ${response.data.message}`,
                    filial: `${store.title}__${store.path}`,
                    calenderid: store.calenderid,
                    services: state.selectedServices.join(','),
                    step: `${(getters.getActiveStep(state) + 1)}) ${state.steps[getters.getActiveStep(state)].name}`,
                    _step_id: (getters.getActiveStep(state) + 1),
                    _step_name: state.steps[getters.getActiveStep(state)].name
                }
            }
            dispatch('notification/add', notification,
                {
                    root: true
                }
            )
            dispatch('errorLoading', null,
                {
                    root: true
                }
            )
        }
    else{
            if(cancellation===1){
                const notification = {
                    type: 'success',
                    message: Drupal.t('Your appointement has been canceled!')
                }
                dispatch('notification/add', notification,
                    {
                        root: true
                    }
                )
                commit('SET_APPOINTEMENT_DELETED');
            }
        }
    })
    .finally(() => {
        commit('DELETE_RESERVATION')
        dispatch('stopLoading', null,
        {
            root: true
        }
    )
    })
    .catch(error => {
            const notification = {
                type: 'error',
                message: state.steps[getters.getActiveStep(state)].error,
                direct: true,
                sending: {
                    type: error.message.indexOf('timeout') !== -1 ? 'timeout' : 'api-error',
                    source: 'delete/reservations',
                    referer: window.location.href,
                    error: error.message,
                    filial: `${store.title}__${store.path}`,
                    calenderid: store.calenderid,
                    services: state.selectedServices.join(','),
                    step: `${(getters.getActiveStep(state) + 1)}) ${state.steps[getters.getActiveStep(state)].name}`,
                    _step_id: (getters.getActiveStep(state) + 1),
                    _step_name: state.steps[getters.getActiveStep(state)].name
                }
            }
            dispatch('notification/add', notification,
        {
            root: true
        }
    )
        dispatch('errorLoading', null,
            {
                root: true
            }
        )
    })
    },
    createAppointement ({ commit, dispatch, state }, {store, calenderid, company_id , reservation_id , secret , fields}) {
        dispatch('startLoading', { message: Drupal.t('Creating appointment ...') }, { root: true })
        BookerService.postAppointement(calenderid ,reservation_id , secret , fields)
            .then(response => {
            if (response.data.error !== undefined) {
            const notification = {
                type: 'error',
                message: state.steps[getters.getActiveStep(state)].error,
                direct: true,
                sending: {
                    type: response.data.message.indexOf('timeout') !== -1 ? 'timeout' : 'api-error',
                    source: 'post/appointment',
                    referer: window.location.href,
                    error: `Error ${response.data.error} : ${response.data.message}`,
                    filial: `${store.title}__${store.path}`,
                    calenderid: store.calenderid,
                    services: state.selectedServices.join(','),
                    step: `${(getters.getActiveStep(state) + 1)}) ${state.steps[getters.getActiveStep(state)].name}`,
                    _step_id: (getters.getActiveStep(state) + 1),
                    _step_name: state.steps[getters.getActiveStep(state)].name
                }
            }
            dispatch('notification/add', notification,
                {
                    root: true
                }
            )
            dispatch('errorLoading', null,
                {
                    root: true
                }
            )
        } else {
            //console.log(response.data.data.finaliseOnlineEventReservation)
            if (response.data.data.finaliseOnlineEventReservation !== undefined) {
                commit('SET_CREATED', true)
                response.data.data.finaliseOnlineEventReservation.calenderid = calenderid;
               // DrupalMailService.sendCreation(response.data.data.finaliseOnlineEventReservation).then(response => {})
                const notification = {
                    type: 'success',
                    message: Drupal.t('Your appointment has been booked. We are looking forward to your visit!')
                }
                dispatch('notification/add', notification,
                    {
                        root: true
                    }
                )
            }
        }
    }).finally(() => {
            dispatch('stopLoading', null,
        {
            root: true
        }
    )
    })
    .catch(error => {
            const notification = {
                type: 'error',
                message: state.steps[getters.getActiveStep(state)].error,
                direct: true,
                sending: {
                    type: error.message.indexOf('timeout') !== -1 ? 'timeout' : 'api-error',
                    source: 'post/appointment/',
                    referer: window.location.href,
                    error: error.message,
                    filial: `${store.title}__${store.path}`,
                    calenderid: store.calenderid,
                    services: state.selectedServices.join(','),
                    step: `${(getters.getActiveStep(state) + 1)}) ${state.steps[getters.getActiveStep(state)].name}`,
                    _step_id: (getters.getActiveStep(state) + 1),
                    _step_name: state.steps[getters.getActiveStep(state)].name
                }
            }
            dispatch('notification/add', notification,
        {
            root: true
        }
     )
        dispatch('errorLoading', null,
            {
                root: true
            }
        )
     })
    },
    getAppointement ({ commit, dispatch, state }, {appid , calenderid}) {
        dispatch('startLoading', { message: Drupal.t('getting appointment ...') }, { root: true })
        EterminService.getAppointement(appid ,calenderid)
            .then(response => {
            if (response.data.error !== undefined) {
            const notification = {
                type: 'error',
                message: state.steps[getters.getActiveStep(state)].error,
                direct: true,
                sending: {
                    type: response.data.message.indexOf('timeout') !== -1 ? 'timeout' : 'api-error',
                    source: 'get/appointment/',
                    referer: window.location.href,
                    error: `Error ${response.data.error} : ${response.data.message}`,
                    calenderid: calenderid,
                    _step_id: (getters.getActiveStep(state) + 1),
                    _step_name: state.steps[getters.getActiveStep(state)].name
                }
            }
            dispatch('notification/add', notification,
                {
                    root: true
                }
            )
            dispatch('errorLoading', null,
                {
                    root: true
                }
            )
        } else {
            let booking = response.data.data.bookings
            if (booking.length > 0) {
                response.data.data.calenderid = calenderid;
                commit('PUSH_GENEREATED_APPOINTEMENT', response.data.data)
                dispatch('store/fetchByCalenderId', {calenderid: 'all', timifyid: calenderid},
                    {
                        root: true
                    }
                )
            } else {
                const notification = {
                    type: 'error',
                    message: Drupal.t('Appointement not found.')
                }
                dispatch('notification/add', notification,
                    {
                        root: true
                    }
                )
                dispatch('errorLoading', null,
                    {
                        root: true
                    }
                )
            }
        }
    }).finally(() => {
            dispatch('stopLoading', null,
        {
            root: true
        }
    )
    })
    .catch(error => {
            const notification = {
                type: 'error',
                message: state.steps[getters.getActiveStep(state)].error,
                direct: true,
                sending: {
                    type: error.message.indexOf('timeout') !== -1 ? 'timeout' : 'api-error',
                    source: 'get/appointment/',
                    referer: window.location.href,
                    error: error.message,
                    calenderid: calenderid,
                    services: state.selectedServices.join(','),
                    step: `${(getters.getActiveStep(state) + 1)}) ${state.steps[getters.getActiveStep(state)].name}`,
                    _step_id: (getters.getActiveStep(state) + 1),
                    _step_name: state.steps[getters.getActiveStep(state)].name
                }
            }
            dispatch('notification/add', notification,
        {
            root: true
        }
    )
        dispatch('errorLoading', null,
            {
                root: true
            }
        )
    })
    },
    deleteAppointement ({ commit, dispatch, state }, {store, appid , calenderid}) {
        dispatch('startLoading', { message: Drupal.t('deleting appointment ...') }, { root: true })
        EterminService.deleteAppointement(appid ,calenderid)
            .then(response => {
            if (response.data.error !== undefined) {
            const notification = {
                type: 'error',
                message: state.steps[getters.getActiveStep(state)].error,
                direct: true,
                sending: {
                    type: response.data.message.indexOf('timeout') !== -1 ? 'timeout' : 'api-error',
                    source: 'delete/appointment/',
                    referer: window.location.href,
                    error: `Error ${response.data.error} : ${response.data.message}`,
                    filial: `${store.title}__${store.path}`,
                    calenderid: calenderid,
                    _step_id: (getters.getActiveStep(state) + 1),
                    _step_name: state.steps[getters.getActiveStep(state)].name
                }
            }
            dispatch('notification/add', notification,
                {
                    root: true
                }
            )
            dispatch('errorLoading', null,
                {
                    root: true
                }
            )
        } else {
            const notification = {
                type: 'success',
                message: Drupal.t('Your appointement has been canceled!')
            }
            dispatch('notification/add', notification,
                {
                    root: true
                }
            )
            commit('SET_APPOINTEMENT_DELETED');
            console.log(response);
        }
    }).finally(() => {
            dispatch('stopLoading', null,
        {
            root: true
        }
    )
    })
    .catch(error => {
            const notification = {
                type: 'error',
                message: state.steps[getters.getActiveStep(state)].error,
                direct: true,
                sending: {
                    type: error.message.indexOf('timeout') !== -1 ? 'timeout' : 'api-error',
                    source: 'delete/appointment/',
                    referer: window.location.href,
                    error: error.message,
                    calenderid: calenderid,
                    services: state.selectedServices.join(','),
                    filial: `${store.title}__${store.path}`,
                    step: `${(getters.getActiveStep(state) + 1)}) ${state.steps[getters.getActiveStep(state)].name}`,
                    _step_id: (getters.getActiveStep(state) + 1),
                    _step_name: state.steps[getters.getActiveStep(state)].name
                }
            }
            dispatch('notification/add', notification,
        {
            root: true
        }
    )
        dispatch('errorLoading', null,
            {
                root: true
            }
        )
    })
    },
    getDeprecatedAppointement ({ commit, dispatch, state }, {appid}) {
        dispatch('startLoading', { message: Drupal.t('Getting appointement ...') }, { root: true })
        EterminDeprecatedService.getAppointement(appid)
            .then(response => {
                if (response.data.error !== undefined) {
                    const notification = {
                        type: 'error',
                        message: Drupal.t('Error getting appointement informations.'),
                        sending: {
                            type: response.data.message.indexOf('timeout') !== -1 ? 'timeout' : 'api-error',
                            source: 'get/appointment/',
                            referer: window.location.href,
                            error: response.data.message,
                            step: `${(getters.getActiveStep(state) + 1)}) ${state.steps[getters.getActiveStep(state)].name}`,
                            _step_id: (getters.getActiveStep(state) + 1),
                            _step_name: state.steps[getters.getActiveStep(state)].name
                        }
                    }
                    dispatch('notification/add', notification,
                        {
                            root: true
                        }
                    )
                    dispatch('errorLoading', null,
                        {
                            root: true
                        }
                    )
                } else {
                    if (response.data.length > 0) {
                        commit('PUSH_DEPRECATED_GENEREATED_APPOINTEMENT', response.data[0])
                        dispatch('store/fetchByCalenderId', {calenderid: response.data[0].CalendarID, timifyid:'all'},
                            {
                                root: true
                            }
                        )
                    } else {
                        const notification = {
                            type: 'error',
                            message: Drupal.t('Appointement not found.')
                        }
                        dispatch('notification/add', notification,
                            {
                                root: true
                            }
                        )
                        dispatch('errorLoading', null,
                            {
                                root: true
                            }
                        )
                    }
                }
            }).finally(() => {
            dispatch('stopLoading', null,
                {
                    root: true
                }
            )
        })
            .catch(error => {
                const notification = {
                    type: 'error',
                    message: Drupal.t('Error getting appointement informations'),
                    sending: {
                        type: error.message.indexOf('timeout') !== -1 ? 'timeout' : 'api-error',
                        source: 'get/appointment/',
                        referer: window.location.href,
                        error: error.message,
                        step: `${(getters.getActiveStep(state) + 1)}) ${state.steps[getters.getActiveStep(state)].name}`,
                        _step_id: (getters.getActiveStep(state) + 1),
                        _step_name: state.steps[getters.getActiveStep(state)].name
                    }
                }
                dispatch('notification/add', notification,
                    {
                        root: true
                    }
                )
                dispatch('errorLoading', null,
                    {
                        root: true
                    }
                )
            })
    },
    deleteDeprecatedAppointement ({ commit, dispatch, state }, {store, termin, data}) {
        dispatch('startLoading', { message: Drupal.t('Deleting appointment ...') }, { root: true })
        EterminDeprecatedService.deleteAppointement(data)
            .then(response => {
                if (response.data.error !== undefined) {
                    const notification = {
                        type: 'error',
                        message: state.steps[getters.getActiveStep(state)].error,
                        sending: {
                            type: response.data.message.indexOf('timeout') !== -1 ? 'timeout' : 'api-error',
                            source: 'delete/appointment/',
                            referer: window.location.href,
                            error: response.data.message,
                            filial: `${store.title}__${store.path}`,
                            calenderid: store.calenderid,
                            services: state.selectedServices.join(','),
                            appointement: `${termin.start} - ${termin.end}`,
                            step: `${(getters.getActiveStep(state) + 1)}) ${state.steps[getters.getActiveStep(state)].name}`,
                            _step_id: (getters.getActiveStep(state) + 1),
                            _step_name: state.steps[getters.getActiveStep(state)].name
                        }
                    }
                    dispatch('notification/add', notification,
                        {
                            root: true
                        }
                    )
                    dispatch('errorLoading', null,
                        {
                            root: true
                        }
                    )
                } else {
                    if (response.data.code === 200) {
                        const notification = {
                            type: 'success',
                            message: Drupal.t('Your appointement has been canceled!')
                        }
                        dispatch('notification/add', notification,
                            {
                                root: true
                            }
                        )
                        commit('SET_APPOINTEMENT_DELETED');
                    }
                }
            }).finally(() => {
            dispatch('stopLoading', null,
                {
                    root: true
                }
            )
        })
            .catch(error => {
                const notification = {
                    type: 'error',
                    message: state.steps[getters.getActiveStep(state)].error,
                    sending: {
                        type: error.message.indexOf('timeout') !== -1 ? 'timeout' : 'api-error',
                        source: 'delete/appointment/',
                        referer: window.location.href,
                        error: error.message,
                        filial: `${store.title}__${store.path}`,
                        calenderid: store.calenderid,
                        services: state.selectedServices.join(','),
                        appointement: `${termin.start} - ${termin.end}`,
                        step: `${(getters.getActiveStep(state) + 1)}) ${state.steps[getters.getActiveStep(state)].name}`,
                        _step_id: (getters.getActiveStep(state) + 1),
                        _step_name: state.steps[getters.getActiveStep(state)].name
                    }
                }
                dispatch('notification/add', notification,
                    {
                        root: true
                    }
                )
                dispatch('errorLoading', null,
                    {
                        root: true
                    }
                )
            })
    },
    /*postNotification ({ commit, dispatch, state }, {calenderid}) {
        dispatch('startLoading', { message: Drupal.t('post notification ...') }, { root: true })
        EterminService.postNotification(calenderid)
            .then(response => {
            if (response.data.error !== undefined) {
            const notification = {
                type: 'error',
                message: state.steps[getters.getActiveStep(state)].error,
                direct: true,
                sending: {
                    type: response.data.message.indexOf('timeout') !== -1 ? 'timeout' : 'api-error',
                    source: 'post/notification/',
                    referer: window.location.href,
                    error: `Error ${response.data.error} : ${response.data.message}`,
                    calenderid: calenderid,
                    _step_id: (getters.getActiveStep(state) + 1),
                    _step_name: state.steps[getters.getActiveStep(state)].name
                }
            }
            dispatch('notification/add', notification,
                {
                    root: true
                }
            )
            dispatch('errorLoading', null,
                {
                    root: true
                }
            )
        } else {
            console.log(response.data.data);
        }
    }).finally(() => {
            dispatch('stopLoading', null,
        {
            root: true
        }
    )
    })
    .catch(error => {
            const notification = {
                type: 'error',
                message: state.steps[getters.getActiveStep(state)].error,
                direct: true,
                sending: {
                    type: error.message.indexOf('timeout') !== -1 ? 'timeout' : 'api-error',
                    source: 'post/notification/',
                    referer: window.location.href,
                    error: error.message,
                    calenderid: calenderid,
                    services: state.selectedServices.join(','),
                    step: `${(getters.getActiveStep(state) + 1)}) ${state.steps[getters.getActiveStep(state)].name}`,
                    _step_id: (getters.getActiveStep(state) + 1),
                    _step_name: state.steps[getters.getActiveStep(state)].name
                }
            }
            dispatch('notification/add', notification,
        {
            root: true
        }
    )
        dispatch('errorLoading', null,
            {
                root: true
            }
        )
    })
    },*/
    selectDate ({ commit, dispatch }, date) {
        commit('SET_DATE', date)
    },
    updateSteps ({ commit, dispatch }, index) {
        commit('SET_STEP', index)
    },
    validateStep ({ commit, dispatch }, {index, status}) {
        commit('VALIDATE_STEP', {index, status})
    },
    resetCreated ({ commit, dispatch }) {
        commit('SET_CREATED', false)
    }
}

export const getters = {
    getcelenderServiceID: state => id => {
        return state.calenderServices.find(calenderService => calenderService.serviceid === id)
    },
    getServiceName: state => id => {
        return state.services.find(services => services.id === id).name
    },
    getServiceImage: state => id => {
       return window.location.protocol + "//" + location.host +'/themes/custom/avonis/images/timify/'+state.services.find(services => services.id === id).externalId.replace(/\s/g, '').replace('(', '').replace(')', '') +'.png';
    },
    getServiceStatus: state => index => {
        return state.steps[index].status
    },
    getReservation: state => {
        return state.reservation
    },
    getActiveStep: state => {
        return state.steps.findIndex((steps) => steps.status === 'active')
    },
    getAppointementEnd: state => (id, date, time) => {
       let serviceDuration = state.services.find(services => services.id === id).duration
       let endDate = moment(moment(date).format('YYYY-MM-DD') + ' '+ time, 'YYYY-MM-DD HH:mm').add(serviceDuration, 'minutes');
       if(endDate.isValid()){
           return endDate.format('HH:mm')
       }
       return ''

    },
    getTime: state => value => {
        if (value) {
            var time = value.toString().split('T').pop()
            return time.substring(0, time.length - 3)
        }
    },
    getDate: state => value => {
        return moment(value).format('dddd, DD. MMMM YYYY')
    }
}
